import React, { useState } from 'react';
import { kullaniciLogin } from '../services/apiService';
import { HiLockClosed, HiUser, HiEye, HiEyeOff, HiShieldCheck } from 'react-icons/hi';
import ForgotPasswordModal from '../components/ForgotPasswordModal';
import './LoginPage.css';

const LoginPage = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await kullaniciLogin(credentials.username, credentials.password);

      if (response.success) {
        const user = {
          kullaniciId: response.kullanici.kullaniciId,
          username: response.kullanici.kullaniciAdi,
          name: response.kullanici.ad,
          email: response.kullanici.email,
          role: response.kullanici.rol,
          okulId: response.kullanici.okulId,
          okulAdi: response.kullanici.okulAdi,
          collectionId: response.kullanici.collectionId,
          loginTime: new Date().toISOString()
        };

        localStorage.setItem('kres_user', JSON.stringify(user));
        onLogin(user);
      } else {
        setError(response.mesaj || 'Kullanıcı adı veya şifre hatalı!');
        setLoading(false);
      }
    } catch (err) {
      setError('Giriş hatası. Lütfen tekrar deneyin.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Animated Background */}
      <div className="login-bg">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="login-container animate-slideUp">
        {/* Logo & Header */}
        <div className="login-header">
          <div className="logo-circle">
            <HiShieldCheck className="logo-icon" />
          </div>
          <h1 className="login-title">Güvenli Yüz Tanıma Sistemi</h1>
          <p className="login-subtitle">Yönetici Girişi</p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="login-form">
          {/* Username Input */}
          <div className="form-field">
            <label htmlFor="username" className="form-label">
              Kullanıcı Adı
            </label>
            <div className="input-wrapper">
              <HiUser className="input-icon" />
              <input
                id="username"
                type="text"
                className="form-input"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                placeholder="Kullanıcı adınızı girin"
                required
                autoFocus
                disabled={loading}
              />
            </div>
          </div>

          {/* Password Input */}
          <div className="form-field">
            <label htmlFor="password" className="form-label">
              Şifre
            </label>
            <div className="input-wrapper">
              <HiLockClosed className="input-icon" />
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                className="form-input"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                placeholder="Şifrenizi girin"
                required
                disabled={loading}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? <HiEyeOff /> : <HiEye />}
              </button>
            </div>
          </div>

          {/* Forgot Password Link */}
          <div className="forgot-password-link">
            <button
              type="button"
              onClick={() => setShowForgotModal(true)}
              className="link-button"
            >
              Şifremi Unuttum
            </button>
          </div>

          {/* Error Message */}
          {error && (
            <div className="login-error animate-slideDown">
              <svg className="error-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="spinner-sm"></div>
                <span>Giriş yapılıyor...</span>
              </>
            ) : (
              <>
                <HiLockClosed />
                <span>Giriş Yap</span>
              </>
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="login-footer">
          <div className="footer-badges">
            <span className="badge">🔒 Güvenli</span>
            <span className="badge">⚡ Hızlı</span>
            <span className="badge">🛡️ Korumalı</span>
          </div>
          <p className="footer-text">Güvenli Yüz Tanıma Sistemi v2.0</p>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgotModal && (
        <ForgotPasswordModal onClose={() => setShowForgotModal(false)} />
      )}
    </div>
  );
};

export default LoginPage;
